import { ThemeSlug } from './common';

export type ThemeFonts = {
  primary: FontDef;
};

type FontDef = {
  family: string;
};

/**
 * exports theme object
 */
export const themeFonts: Record<ThemeSlug, ThemeFonts> = {
  next: {
    primary: { family: 'Gilroy' },
  },
  classic: {
    primary: { family: 'Roboto' },
  },
};
